export const PrintButtonStyle = () => ({
  padding: '0 !important',
  height: 'auto',
  '&:hover': {
    backgroundColor: 'transparent'
  }
});
